import de from './de.json';
import deCH from './de-CH.json';
import en from './en.json';
import enGB from './en-GB.json';
import enUS from './en-US.json';
import enZA from './en-ZA.json';
import es from './es.json';
import fi from './fi.json';
import fr from './fr.json';
import it from './it.json';
import sl from './sl.json';
import ro from './ro';
import bhs_en from './bhs/en.json';
import vir_en from './vir/en.json';
import pri_en from './pri/en.json';
import zaf_en from './zaf/en.json';

const messages = {
  de,
  en: { ...en, ...vir_en }, // ??
  es,
  fi,
  fr,
  it,
  sl,
  ro,
  'en-GB': enGB,
  'en-US': enUS,
  'en-ZA': { ...enZA, ...zaf_en },
  'es-ES': es,
  'de-CH': deCH,
  'ro-RO': ro,
  'en-PR': { ...enUS, ...pri_en },
  'en-BS': { ...enUS, ...bhs_en },
};

export default { messages, invariant: 'de' };



// WEBPACK FOOTER //
// ./src/app/@propnow/locales/index.js